export type MinimalUserRef = { id?: string; uid?: string; username?: string | null | undefined };

const reservedProfilePaths = new Set([
  'about', 'admin-dashboard', 'ads', 'analytics', 'appeals', 'artist-verification',
  'connections', 'conversions', 'create-ad', 'creator-studio', 'docs', 'earnings',
  'go-live', 'groups', 'guides', 'help', 'home', 'live', 'login', 'messages',
  'music-library', 'notifications', 'pages', 'playbook', 'privacy', 'profile',
  'pulse', 'saved', 'search', 'settings', 'signup', 'stories', 'studio',
  'terms', 'testimony', 'wallet-transactions', 'advertiser-dashboard',
  '.well-known', 'asset-manifest.json', 'apple-touch-icon.png', 'belivah-image.png',
  'favicon.ico', 'favicon.svg', 'index.html', 'logo192.png', 'logo512.png',
  'manifest.json', 'robots.txt', 'static',
]);

export function getUsernameProfileUrl(username?: string | null): string | null {
  const handle = (username || '').trim();
  if (!/^[A-Za-z0-9._-]+$/.test(handle)) return null;
  if (handle === '.' || handle === '..') return `/u/@${handle}`;
  if (reservedProfilePaths.has(handle.toLowerCase())) return `/u/${encodeURIComponent(handle)}`;
  return `/${encodeURIComponent(handle)}`;
}

/**
 * Returns the canonical profile URL.
 * Some list APIs use "user" as a placeholder, so resolve that value by ID when possible.
 */
export function getProfileUrl(u: MinimalUserRef): string {
  const username = (u.username || '').toString().trim();
  const id = (u.uid || u.id || '').toString().trim();
  const usernameUrl = getUsernameProfileUrl(username);
  if (usernameUrl && (username.toLowerCase() !== 'user' || !id)) return usernameUrl;
  return id ? `/profile/${encodeURIComponent(id)}` : '/profile';
}
